import { CheckIcon } from "./icons";

import "../../../styles/panel/user/PlanStep.css";
import { useEffect, useState } from "react";
import { fetchPlans } from "../../../api/storeRequest";

export default function PlanStep({ plan, setPlan }) {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    const load = async () => {
      const t = await fetchPlans();
      setPlans(t?.data || []);
    };
    load();
  }, []);
  return (
    <>
      <h3 className="request-step-title">انتخاب پلن</h3>
      <p className="request-step-sub">پلن مناسب کسب‌وکارت رو انتخاب کن</p>

      <div className="plan-list">
        {plans.map((p) => (
          <div
            key={p.plan_id}
            className={`plan-row${
              plan?.id === p.plan_id ? " selected" : ""
            }${p.popular ? " popular" : ""}`}
            onClick={() =>
              setPlan({
                id: p.plan_id,
                name: p.title,
                price: p.price,
              })
            }
          >
            <span className="plan-radio">
              <span className="plan-radio-dot" />
            </span>

            <div className="plan-row-main">
              <div className="plan-name">
                {p.title}
                {p.popular && <span className="plan-badge">پیشنهاد ویژه</span>}
              </div>
            </div>

            <div className="plan-price">
              <span className="amount">
                {Number(p?.price).toLocaleString("en-US")}
              </span>
              <span className="unit">هزار تومان / ماه</span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
export function isPlanStepValid(plan) {
  return !!plan;
}
